import estimationService from "@/services/estimationService";

const getEstimation = async (context) => {
  let contract = context.rootState.contract;

  let energies = [];
  let hasElec = context.rootGetters["contract/hasElec"];

  if(hasElec) energies.push("electricity");
  if(context.rootGetters["contract/hasGas"]) energies.push("gas");

  let pricingOption = null;
  let exclusiveNight = false;

  if(hasElec) {
    pricingOption = context.rootGetters["contract/hasTou"] ? "HPHC" : "BASE";
    exclusiveNight = context.rootGetters["contract/hasNight"] === 1;
  }

  let houseSize = ["between_0_and_25",
    "between_26_and_50",
    "between_51_and_75",
    "between_76_and_100",
    "between_101_and_150",
    "between_151_and_200",
    "more_200"];

  let payload = {
    energies: energies,
    emptyHouse: contract.unoccupied === 1,
    pricingOption: pricingOption,
    exclusiveNight: exclusiveNight,
    people: contract.inhabitants + 1,
    houseSize: houseSize[context.state.houseSize],
    occupation: context.state.occupation,
    heating: context.state.heating,
    water: context.state.water,
    dishwasher: context.state.dishwasher,
    dryer: context.state.dryer,
    washingMachine: context.state.washingMachine,
    solarPanelsPower: contract.electricity.solarPanelPower | 0,
    solarPanelsScenario: contract.electricity.solarPanelScenario,
    electricCar: context.state.electricCar | 0,
    battery: context.state.battery | 0
  }

  try {
    let response = await estimationService.getEstimation(payload);
    if(response.gas) context.commit("setConsumptionsGas", response.gas.total);
    if(response.electricity) {
      if(response.electricity.total) context.commit("setConsumptionsMono", response.electricity.total);
      if(response.electricity.day) context.commit("setConsumptionsDay", response.electricity.day);
      if(response.electricity.night) context.commit("setConsumptionsNight", response.electricity.night);
      if(response.electricity.exclusiveNight) context.commit("setConsumptionsExclusiveNight", response.electricity.exclusiveNight);
      if(response.electricity.injectionBase) context.commit("setConsumptionsInjectionBase", response.electricity.injectionBase);
      if(response.electricity.injectionDay) context.commit("setConsumptionsInjectionDay", response.electricity.injectionDay);
      if(response.electricity.injectionNight) context.commit("setConsumptionsInjectionNight", response.electricity.injectionNight);
    }
  } catch (error) {
    throw error;
  }
};

const setConsumption = async (context, lead) => {
  if(lead.knowConsumption) context.commit('setKnowConsumption', lead.knowConsumption);
  if(lead.consumptionElecBase) context.commit('setConsumptionsMono', lead.consumptionElecBase);
  if(lead.consumptionElecHigh) context.commit('setConsumptionsDay', lead.consumptionElecHigh);
  if(lead.consumptionElecLow) context.commit('setConsumptionsNight', lead.consumptionElecLow);
  if(lead.consumptionElecNight) context.commit('setConsumptionsExclusiveNight', lead.consumptionElecNight);
  if(lead.injectionElecBase) context.commit('setConsumptionsInjectionBase', lead.injectionElecBase);
  if(lead.injectionElecHigh) context.commit('setConsumptionsInjectionDay', lead.injectionElecHigh);
  if(lead.injectionElecLow) context.commit('setConsumptionsInjectionNight', lead.injectionElecLow);
  if(lead.consumptionGas) context.commit('setConsumptionsGas', lead.consumptionGas);
  if(lead.people) context.commit('setInhabitants', parseInt(lead.people));
  if(lead.houseSize) context.commit('setHouseSize', parseInt(lead.houseSize));
  if(lead.occupation) context.commit('setOccupation', lead.occupation);
  if(lead.heating) context.commit('setHeating', lead.heating);
  if(lead.water) context.commit('setWater', lead.water);
  if(lead.dishwasher) context.commit('setDishwasher', lead.dishwasher);
  if(lead.dryer) context.commit('setDryer', lead.dryer);
  if(lead.washingMachine) context.commit('setWashingMachine', lead.washingMachine);
  if(lead.electricCar) context.commit('setElectricCar', lead.electricCar);
  if(lead.battery) context.commit('setBattery', lead.battery);
  if(lead.hasSmartMeter) context.commit("setHasSmartMeter", lead.hasSmartMeter);
  if(lead.hasQuarterRegime) context.commit("setHasQuarterRegime", lead.hasQuarterRegime);
  if(lead.knowPeakLevel) context.commit("setKnowPeakLevel", lead.knowPeakLevel);
  if(lead.peakLevel) context.commit("setPeakLevel", lead.peakLevel);
};

const setConsumptionWithContract = async (context, contract) => {
  if(contract.electricity) {
    if(contract.electricity.consumption.exclusive_night) context.commit('setConsumptionsExclusiveNight', contract.electricity.consumption.exclusive_night);
    if(contract.electricity.consumption.base) context.commit('setConsumptionsMono', contract.electricity.consumption.base);
    if(contract.electricity.consumption.high) context.commit('setConsumptionsDay', contract.electricity.consumption.high);
    if(contract.electricity.consumption.low) context.commit('setConsumptionsNight', contract.electricity.consumption.low);
    if(contract.electricity.consumption.injectionBase) context.commit('setConsumptionsInjectionBase', contract.electricity.consumption.injectionBase);
    if(contract.electricity.consumption.injectionNight) context.commit('setConsumptionsInjectionNight', contract.electricity.consumption.injectionNight);
    if(contract.electricity.consumption.injectionDay) context.commit('setConsumptionsInjectionDay', contract.electricity.consumption.injectionDay);
  }

  if(contract.gas) {
    if(contract.gas.consumption) context.commit('setConsumptionsGas', contract.gas.consumption);
  }
}

const recomputeActiveConsumptionValues = (context, add) => {
  let recomputedConsumptions = { ...context.state.consumptions.electricity }

  for (let meter in context.state.consumptions.electricity) {
      let newValue = null;
      let injection = null;
      let currVal = context.state.consumptions.electricity[meter] ? parseInt(context.state.consumptions.electricity[meter]) : null;
      switch (meter) {
        case 'mono':
          injection = parseInt(context.state.consumptions.electricity.injectionBase);
          if(currVal)
            newValue = add ? currVal + ((injection ? (injection / 0.7) : 0) * 0.3) :
                           currVal - ((injection ? injection : 0) * 0.3);
          else newValue = null
          if(newValue) context.commit('contract/setElectricityConsumptionBase', Math.round(newValue), {root:true})
          break;
        case 'day':
          injection = parseInt(context.state.consumptions.electricity.injectionDay);
          if(currVal)
            newValue = add ? currVal + ((injection ? (injection / 0.7) : 0) * 0.3) :
                           currVal - ((injection ? injection : 0) * 0.3);
          else newValue = null
          if(newValue) context.commit('contract/setElectricityConsumptionHigh', Math.round(newValue), {root:true})
          break;
        case 'night':
          injection = parseInt(context.state.consumptions.electricity.injectionNight);
          if(currVal)
            newValue = add ? currVal + ((injection ? (injection / 0.7) : 0) * 0.3) :
                           currVal - ((injection ? injection : 0) * 0.3);
          else newValue = null
          if(newValue) context.commit('contract/setElectricityConsumptionLow', Math.round(newValue), {root:true})
          break;
        case 'exclusiveNight':
          newValue = currVal;
          break;
        case 'injectionBase':
          if(currVal)
            newValue = add ? currVal / 0.7 : currVal * 0.7;
          else newValue = null;
          if(newValue) context.commit('contract/setElectricityInjectionBase', Math.round(newValue), {root:true})
          break;
        case 'injectionNight':
          if(currVal)
            newValue = add ? currVal / 0.7 : currVal * 0.7;
          else newValue = null;
          if(newValue) context.commit('contract/setElectricityInjectionLow', Math.round(newValue), {root:true})
          break;
        case 'injectionDay':
          if(currVal)
            newValue = add ? currVal / 0.7 : currVal * 0.7;
          else newValue = null;
          if(newValue) context.commit('contract/setElectricityInjectionHigh', Math.round(newValue), {root:true})
          break;
      }

      if (newValue !== null) {  
        recomputedConsumptions[meter] = Math.round(newValue);
      }
  }

  context.commit('setConsumptionsElectricity', recomputedConsumptions)
}

const computePeakLevel = (context) => {
  const basePeakLevel = 2.5;
	const consumption = context.rootGetters['contract/hasMono'] ? parseFloat(context.state.consumptions.electricity.mono) : parseFloat(context.state.consumptions.electricity.day) + parseFloat(context.state.consumptions.electricity.night);
	const injection = context.rootGetters['contract/hasInjectionBase'] ? parseFloat(context.state.consumptions.electricity.injectionBase) : (context.rootGetters['contract/hasInjectionTou'] ? parseFloat(context.state.consumptions.electricity.injectionDay) + parseFloat(context.state.consumptions.electricity.injectionNight) : null);
  const exclusiveNight = context.rootGetters['contract/hasNight'] ? parseFloat(context.state.consumptions.electricity.exclusiveNight) : null;
  const solarPanelPower = context.rootGetters['contract/hasSolarPanel'] ? parseFloat(context.rootState.contract.electricity.solarPanelPower) : null;

	const peakLevel = Math.max(basePeakLevel, computeFormula(consumption, injection, exclusiveNight, solarPanelPower));
  context.commit('setPeakLevel', peakLevel.toString());
}

const computeFormula = (consumption, injection = null, exclusiveNightConsumption = null, solarPanelPower = null) => {
  const totalConsumption = consumption + (injection ? getAutoConsumption(injection) : 0);
  const exclNightFormulaPart = exclusiveNightConsumption ? 0.0007876 * exclusiveNightConsumption : 0;
  const solarPanelFormulaPart = solarPanelPower ? 0.02464 * getMaxSolarPanelPower(solarPanelPower) : 0;
  return 2.73 * Math.log((totalConsumption / 931) + 1) + exclNightFormulaPart - solarPanelFormulaPart;
}

const getAutoConsumption = (injection) => {
  return (injection / 0.64) - injection;
}

const getMaxSolarPanelPower = (solarPanelPower) => {
  return solarPanelPower * 10 / 9;
}

export default {
  getEstimation,
  setConsumption,
  setConsumptionWithContract,
  recomputeActiveConsumptionValues,
  computePeakLevel
};



// WEBPACK FOOTER //
// ./src/store/modules/consumption/actions.js